import React, { FC, useCallback } from 'react'
import { cn } from 'shared/utils'
import { Icon, Badge } from '@wmgtech/legato'

import { IStepItemProps } from './Stepper.props'
import { IconName } from '@fortawesome/fontawesome-common-types'

import styles from './Stepper.module.scss'

const StepItem: FC<IStepItemProps> = ({
  index,
  className,
  isLastStep,
  active,
  disabled,
  completed,
  step,
  onClick
}) => {
  const status = active ? 'In progress' : completed ? 'Completed' : 'Pending'
  const badgeColor = active ? 'dark' : completed ? 'success' : 'white'

  const handleStepClick = useCallback(() => !disabled && onClick(), [disabled, onClick])

  const getIcon = (index: number): IconName => {
    if (completed) return 'circle-check'
    if (active) return 'pen-circle'

    return `circle-${index}` as IconName
  }

  return (
    <>
      <div className={cn(className, styles.step, {
        [styles.stepCompleted]: completed,
        [styles.stepActive]: active
      })}>
        <Icon
          name={getIcon(index)}
          prefix={completed || active ? 'fas' : 'fal'}
          className={styles.stepIcon}
        />
        <div className={styles.stepInfo} onClick={handleStepClick}>
          {step.title && <span className={styles.stepInfoTitle}>{step.title}</span>}
          <Badge className={styles.stepInfoStatus} text={status} size="xs" colorType={badgeColor} containerStyle="solid" />
        </div>
      </div>
      {!isLastStep && <div className={styles.stepProgress} />}
    </>
  )
}

export default StepItem
